
import React from "react";
import { cn } from "@/lib/utils";
import { Dice1, Dice2, Dice3, Dice4, Dice5, Dice6 } from "lucide-react";

interface DiceProps {
  value: number;
  rolling: boolean;
  size?: number;
  className?: string;
  onClick?: () => void;
}

const Dice: React.FC<DiceProps> = ({ 
  value, 
  rolling, 
  size = 80,
  className,
  onClick
}) => {
  const diceIcons = {
    1: Dice1,
    2: Dice2,
    3: Dice3,
    4: Dice4,
    5: Dice5,
    6: Dice6,
  };

  const DiceIcon = diceIcons[value as keyof typeof diceIcons] || Dice1;

  return (
    <div 
      className={cn(
        "relative inline-block w-[140px] h-[140px] flex items-center justify-center",
        className,
        onClick && !rolling ? "cursor-pointer" : ""
      )}
      onClick={!rolling && onClick ? onClick : undefined}
    >
      <div className={cn(
        "absolute inset-0 m-auto flex items-center justify-center",
        rolling ? "animate-[spin_0.5s_ease-in-out_3]" : ""
      )}>
        <div className={cn(
          "bg-[#FBF3F1] rounded-xl p-2 shadow-lg transition-opacity duration-200",
          rolling ? "opacity-70" : "opacity-100 hover:opacity-90"
        )}>
          <DiceIcon size={size} className="text-[#003F6B]" />
        </div>
      </div>
    </div>
  );
};

export default Dice;
